import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { HintBox } from '$components/hint-box/hint-box';
import { helpEmail } from '$components/subscription-dialog/subscription-dialog';

export interface SubscriptionBannerProps {
  /**
   * Icon name to display on the left side of the banner
   */
  iconName: 'phone' | 'calendar' | 'alarm-ringing';
  /**
   * Translation key for the header text
   */
  headerI18nKey: string;
  /**
   * Translation key for the message text (should include {l} placeholder for link)
   */
  messageI18nKey: string;
  /**
   * Optional custom email for the contact link (defaults to helpEmail)
   */
  contactEmail?: string;
  /**
   * Optional CSS class for the icon
   */
  iconClassName?: string;
}

export function SubscriptionBanner({
  iconName,
  headerI18nKey,
  messageI18nKey,
  contactEmail = helpEmail,
  iconClassName = 'm-right-s bg-blue-600',
}: SubscriptionBannerProps) {
  const { t } = useTranslation();

  return (
    <HintBox>
      <Icon name={iconName} size={IconSizeClasses.XSmall} className={iconClassName} />
      <div className="flex flex__dir--column text-align-left">
        <p className="m-bottom-s font-weight-bold">
          {t(headerI18nKey, { defaultValue: headerI18nKey })}
        </p>
        <p className="font-bold font-size-s">
          <Trans
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Dynamic i18n key from props needs type assertion
            i18nKey={messageI18nKey as any}
            defaults={messageI18nKey}
            components={{
              l: <Link to={`mailto:${contactEmail}`} className="color-blue-500" />,
            }}
          />
        </p>
      </div>
    </HintBox>
  );
}
